/**
  @Description:
  import { swal } from '@/assets/js/mixins/base/Swal'

  mixins: [ swal ]

  this.$alert(type, response, options, callback, title)
**/

import $ from 'jquery'
import _ from 'lodash'

export var swal = {
  methods: {
    $alert (type, response = '', options = {}, callback = {}, swalTitle = '') {
      var swalOption = {
        customClass: 'swal--' + type,
        text: null,
        type: null,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        showCancelButton: false,
        reverseButtons: false,
        html: `
        <div class="swal__header">
          <div class="swal__header--inner">
            <div class="swal__title">
              <h2>${swalTitle}</h2>
            </div>
          </div>
        </div>

        <div class="swal__body">
          <p>${response}</p>
        </div>
        `
      }

      if (type === 'prompt') {
        var additionalOptions = { showCancelButton: true }

        swalOption = _.merge(swalOption, additionalOptions)

        if (Object.keys(options).length > 0) {
          swalOption = _.merge(swalOption, options)
        }
      } // prompt

      if (!callback) {
        this.$swal(swalOption)
      } else {
        this.$swal(swalOption).then(result => {
          if (result.value) {
            if (typeof callback === 'function') {
              callback()
            }
            if (typeof callback.success === 'function') {
              callback.success()
            }
          }

          if (!result.value) {
            if (typeof callback.cancel === 'function') {
              callback.cancel()
            }
          }
        })
      }

      if (!response) {
        $('.swal__body').hide()
      }

      $('.swal2-confirm').html('<span>' + '확인' + '</span>')
      $('.swal2-cancel').html('<span>' + '취소' + '</span>')
    } // $alert
  } // methods
} // swal
